module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-16x9-6b263372964a80f256561511f8892733.jpg";